export const MAINTENANCE = "MAINTENANCE";

export function maintenance(payload) {
    return {
        type: MAINTENANCE,
        payload
    };
}
